import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { AlertComponent } from '@components/atoms/alert/alert.component';
import { CardMode } from '@components/card/card.component';
import {
    LodgingPreferencesComponent,
    LodgingPreferencesFormGroup,
} from '@components/molecules/forms/patient-travel-card/lodging-preferences/lodging-preferences.component';
import { MdsDividerComponent, MdsExpansionPanelComponent } from '@medpacesoftwaredevelopment/designsystem';
import { TravelRequest } from '@models/request';
import { Study } from '@models/study';
import { RequestStateService } from '@services/state-management/request-state.service';
import { TravelViewModelService } from '@services/travel-view-model/travel-view-model.service';
import { getAlertContent } from '@utility/utility.travel-request';
import { map } from 'rxjs';
import { LodgingRequestDetailsFormGroup } from '../../form-groups/detail-form-groups/travel/lodging-request.formgroup';
import { NeedsTravelFormGroup, TravelFormGroup } from '../../form-groups/travel-request-card.formgroup';
import { NeedsTravelRadioGroupComponent } from '../../needs-travel-radio-group/needs-travel-radio-group.component';
import { LodgingRequestDetailsComponent } from './lodging-request-details/lodging-request-details.component';

@Component({
    selector: 'medpace-lodging-travel-request-tab',
    imports: [
        CommonModule,
        AlertComponent,
        MdsDividerComponent,
        NeedsTravelRadioGroupComponent,
        LodgingRequestDetailsComponent,
        MdsExpansionPanelComponent,
        LodgingPreferencesComponent,
    ],
    templateUrl: './lodging-travel-request-tab.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './lodging-travel-request-tab.component.scss',
})
export class LodgingTravelRequestTabComponent {
    private readonly requestStateService = inject(RequestStateService);
    private readonly travelViewModelService = inject(TravelViewModelService);

    public readonly mode: InputSignal<CardMode> = input.required();
    public readonly study: InputSignal<Study> = input.required();
    public readonly formGroup: InputSignal<
        NeedsTravelFormGroup<TravelFormGroup<LodgingPreferencesFormGroup, LodgingRequestDetailsFormGroup>>
    > = input.required();

    public readonly isLodgingAvailable: Signal<boolean> = computed(
        () => !!this.study().studyInfo?.studyTravelOptions.find((o) => o.name === 'Hotels')
    );
    public readonly isUpdate = computed(() => !!this.travelViewModelService.travelCardViewModel()?.isUpdate);

    public readonly isLodgingRequested$ = this.requestStateService.travelRequestStateService
        .getState()
        .pipe(map((travelRequest: TravelRequest) => travelRequest?.lodgingRequired));

    public readonly nonAvailableMessage: string = getAlertContent('hotel');
}
